<a
	target="_blank"
	rel="noopener noreferrer"
	[class]="buttonClasses[buttonType()] + ' u-outline layout-spread ' + customButtonClass()"
	[ngClass]="{ 'is-disabled': isDisabled() }"
	[title]="title()"
	[cypressTag]="buttonCypressTag() || 'General.Input.Button'"
	[attr.href]="isDisabled() ? null : link()"
	(click)="handleButtonClick()"
>
	<ng-content />

	<vlaio-icon [icon]="icon() || 'fa-up-right-from-square'"></vlaio-icon>
</a>
